import type { CapturingResult } from './frame-capturer.tsx';

const total = (values: number[]) => {
	let result = 0;
	for (const value of values) {
		result += value;
	}
	return result;
};

const avg = (values: number[]) => {
	if (values.length === 0) {
		throw new Error('Cannot calculate an avg of 0 numbers');
	}
	return total(values) / values.length;
};

export type Measures = {
	fpsAvg: number;
	fpsAvgMin: number;
	latencyAvg: number;
	latencyMax: number;
};

export const processScrollingData = (scrolls: CapturingResult[]): Measures => {
	let latencyMax = 0;

	const scrollLatencyAverages: number[] = [];
	const scrollFpsValues: number[] = [];
	for (const { capturedFrameTimes, capturingStartTime, capturingStopTime } of scrolls) {
		const scrollingDuration = capturingStopTime - capturingStartTime;

		const frameDurations = [];
		for (let i = 1; i < capturedFrameTimes.length; i++) {
			const duration = capturedFrameTimes[i] - capturedFrameTimes[i - 1];
			frameDurations.push(duration);
		}

		latencyMax = Math.max(latencyMax, ...frameDurations);

		scrollLatencyAverages.push(avg(frameDurations));
		scrollFpsValues.push((capturedFrameTimes.length / scrollingDuration) * 1000);
	}

	return {
		latencyAvg: avg(scrollLatencyAverages),
		latencyMax,
		fpsAvg: avg(scrollFpsValues),
		fpsAvgMin: Math.min(...scrollFpsValues),
	};
};
